import { APPLICATION_ROUTES } from 'constants/routes';

export enum UserRoles {
    admin = 'admin',
    owner = 'owner'
}

/** First screen after login: reports for admin/owner, ordering for staff and other roles. */
export function getPostLoginHomePath(roles: { name: string }[] | undefined): string {
    if (!roles?.length) {
        return APPLICATION_ROUTES.ordering.browse;
    }
    const privileged = roles.some((r) => r.name === UserRoles.admin || r.name === UserRoles.owner);
    return privileged ? APPLICATION_ROUTES.dashboard : APPLICATION_ROUTES.ordering.browse;
}

export enum UpdatedUserRolesLabels {
    admin = 'Franchise Partner',
    owner = 'Support Centre',
    staff = 'Team'
}
